import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PasswordInput from '../components/PasswordInput';

const emeklilikEtiketi = { emekli_degil: 'Emekli Degilim', emekli: 'Emekliyim', emekliligi_hak_kazandim: 'Emeklilige Hak Kazandim' };

const ADIMLAR = [
  { id: 'telefon', label: 'Telefon Gorusmesi' },
  { id: 'musteri', label: 'Musteri Gorusmesi' },
  { id: 'teklif', label: 'Is Teklifi' },
  { id: 'sozlesme', label: 'Sozlesme' },
  { id: 'evraklar', label: 'Evraklar' },
];

const MENFAATLER = [
  { key: 'arac', label: 'Sirket Araci' },
  { key: 'yakit', label: 'Yakit Karti' },
  { key: 'telefon', label: 'Telefon' },
  { key: 'laptop', label: 'Laptop' },
  { key: 'prim', label: 'Prim / Bonus' },
];

const aktifAdimHesapla = (aday, teklif) => {
  if (teklif?.durum === 'evraklar_yuklendi') return 4;
  if (teklif?.durum === 'sozlesme_imzalandi') return 4;
  if (teklif?.durum === 'sozlesme_gonderildi') return 3;
  if (teklif?.durum === 'kabul_edildi' || teklif?.durum === 'resmi_gonderildi' || teklif?.durum === 'sozlu_yapildi') return 2;
  if (aday?.musteri_durumu === 'gecti') return 2;
  if (aday?.musteri_durumu) return 1;
  if (aday?.telefon_durumu === 'gecti') return 1;
  if (aday?.telefon_durumu) return 0;
  return 0;
};

const AdayDetayPage = ({ adayId, geriDon }) => {
  const [veri, setVeri] = useState(null);
  const [aktifAdim, setAktifAdim] = useState(null);
  const [telefonForm, setTelefonForm] = useState({ durum: '', tarih: '', saat: '', notlar: '' });
  const [musteriForm, setMusteriForm] = useState({ durum: '', tarih: '', saat: '', yer: '', notlar: '' });
  const [teklifForm, setTeklifForm] = useState({ pozisyon: '', maas: '', baslangic_tarihi: '', teklif_gecerlilik_tarihi: '', notlar: '', ek_menfaatler: [] });
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sifrePaneli, setSifrePaneli] = useState(false);
  const [yeniSifre, setYeniSifre] = useState('');

  const yenile = () => {
    axios.get('/api/adaylar/' + adayId + '/detay').then(r => {
      setVeri(r.data);
      const { telefon, musteri, teklif } = r.data;
      if (telefon) setTelefonForm({ durum: telefon.durum || '', tarih: telefon.tarih || '', saat: telefon.saat || '', notlar: telefon.notlar || '' });
      if (musteri) setMusteriForm({ durum: musteri.durum || '', tarih: musteri.tarih || '', saat: musteri.saat || '', yer: musteri.yer || '', notlar: musteri.notlar || '' });
      if (teklif) setTeklifForm({ pozisyon: teklif.pozisyon || '', maas: teklif.maas || '', baslangic_tarihi: teklif.baslangic_tarihi || '', teklif_gecerlilik_tarihi: teklif.teklif_gecerlilik_tarihi || '', notlar: teklif.notlar || '', ek_menfaatler: JSON.parse(teklif.ek_menfaatler || '[]') });
    }).catch(console.error);
  };

  useEffect(() => { yenile(); }, [adayId]);

  const islem = async (url, data, mesaj) => {
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.post(url, data || {});
      setSonuc({ tip: 'basari', mesaj });
      yenile();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleSil = async () => {
    if (!window.confirm(veri.aday.ad + ' ' + veri.aday.soyad + ' adli adayi silmek istediginize emin misiniz? Bu islem geri alinamaz.')) return;
    try {
      await axios.delete('/api/adaylar/' + adayId);
      geriDon();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Silinemedi.' }); }
  };

  const handleSifreSifirla = async () => {
    if (!yeniSifre || yeniSifre.length < 8) { setSonuc({ tip: 'hata', mesaj: 'Sifre en az 8 karakter olmali.' }); return; }
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/adaylar/' + adayId + '/sifre-sifirla', { yeni_sifre: yeniSifre });
      setSonuc({ tip: 'basari', mesaj: 'Sifre guncellendi.' });
      setSifrePaneli(false);
      setYeniSifre('');
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const menfaatToggle = (key) => setTeklifForm(p => ({ ...p, ek_menfaatler: p.ek_menfaatler.includes(key) ? p.ek_menfaatler.filter(k => k !== key) : [...p.ek_menfaatler, key] }));

  if (!veri) return <div style={{ padding: '2rem', color: 'var(--yazi-ikincil)' }}>Yukleniyor...</div>;

  const { aday, teklif, telefon, musteri } = veri;
  const aktif = aktifAdimHesapla(aday, teklif);

  const adimIcerigi = (adimId) => {
    switch(adimId) {
      case 'telefon':
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {telefon && (
              <div style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '0.75rem 1rem', fontSize: '13px' }}>
                <div><strong>Mevcut Durum:</strong> {telefon.durum}</div>
                {telefon.tarih && <div><strong>Tarih:</strong> {telefon.tarih} {telefon.saat}</div>}
                {telefon.notlar && <div style={{ marginTop: '4px' }}><strong>Not:</strong> {telefon.notlar}</div>}
              </div>
            )}
            <div className="form-group">
              <label>Gorusme Sonucu</label>
              <select value={telefonForm.durum} onChange={e => setTelefonForm({ ...telefonForm, durum: e.target.value })}>
                <option value="">-- Secin --</option>
                <option value="ulasilamadi">Ulasilamadi</option>
                <option value="tarih_belirlendi">Tarih / Saat Belirlendi</option>
                <option value="gecti">Gorusuldu - Gecti</option>
                <option value="elendi">Gorusuldu - Elendi</option>
              </select>
            </div>
            {telefonForm.durum === 'tarih_belirlendi' && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                <div className="form-group"><label>Tarih</label><input type="date" value={telefonForm.tarih} onChange={e => setTelefonForm({ ...telefonForm, tarih: e.target.value })} /></div>
                <div className="form-group"><label>Saat</label><input type="time" value={telefonForm.saat} onChange={e => setTelefonForm({ ...telefonForm, saat: e.target.value })} /></div>
              </div>
            )}
            <div className="form-group"><label>Notlar</label><textarea value={telefonForm.notlar} onChange={e => setTelefonForm({ ...telefonForm, notlar: e.target.value })} rows={3} placeholder="Gorusme notlari..." /></div>
            <button className="btn btn-primary" disabled={yukleniyor || !telefonForm.durum} onClick={() => islem('/api/adaylar/' + adayId + '/telefon-gorusmesi', telefonForm, 'Kaydedildi.')}>
              {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
            </button>
          </div>
        );

      case 'musteri':
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {musteri && (
              <div style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '0.75rem 1rem', fontSize: '13px' }}>
                <div><strong>Mevcut Durum:</strong> {musteri.durum || '-'}</div>
                {musteri.tarih && <div><strong>Tarih:</strong> {musteri.tarih} {musteri.saat}</div>}
                {musteri.yer && <div><strong>Yer:</strong> {musteri.yer}</div>}
                {musteri.notlar && <div style={{ marginTop: '4px' }}><strong>Not:</strong> {musteri.notlar}</div>}
              </div>
            )}
            <div className="form-group">
              <label>Gorusme Sonucu</label>
              <select value={musteriForm.durum} onChange={e => setMusteriForm({ ...musteriForm, durum: e.target.value })}>
                <option value="">-- Secin --</option>
                <option value="beklemede">Beklemede</option>
                <option value="gecti">Gecti</option>
                <option value="elendi">Elendi</option>
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
              <div className="form-group"><label>Tarih</label><input type="date" value={musteriForm.tarih} onChange={e => setMusteriForm({ ...musteriForm, tarih: e.target.value })} /></div>
              <div className="form-group"><label>Saat</label><input type="time" value={musteriForm.saat} onChange={e => setMusteriForm({ ...musteriForm, saat: e.target.value })} /></div>
            </div>
            <div className="form-group"><label>Yer</label><input type="text" value={musteriForm.yer} onChange={e => setMusteriForm({ ...musteriForm, yer: e.target.value })} placeholder="Gorusme yeri..." /></div>
            <div className="form-group"><label>Notlar</label><textarea value={musteriForm.notlar} onChange={e => setMusteriForm({ ...musteriForm, notlar: e.target.value })} rows={3} placeholder="Gorusme notlari..." /></div>
            <button className="btn btn-primary" disabled={yukleniyor} onClick={() => islem('/api/adaylar/' + adayId + '/musteri-gorusmesi', musteriForm, 'Kaydedildi.')}>
              {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
            </button>
          </div>
        );

      case 'teklif':
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {teklif && (
              <div style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '0.75rem 1rem', fontSize: '13px' }}>
                <div><strong>Durum:</strong> {teklif.durum}</div>
                <div><strong>Pozisyon:</strong> {teklif.pozisyon} | <strong>Maas:</strong> {teklif.maas} TL | <strong>Baslangic:</strong> {teklif.baslangic_tarihi}</div>
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
              <div className="form-group"><label>Pozisyon *</label><input type="text" value={teklifForm.pozisyon} onChange={e => setTeklifForm({ ...teklifForm, pozisyon: e.target.value })} /></div>
              <div className="form-group"><label>Maas (TL) *</label><input type="text" value={teklifForm.maas} onChange={e => setTeklifForm({ ...teklifForm, maas: e.target.value })} /></div>
              <div className="form-group"><label>Baslangic Tarihi *</label><input type="date" value={teklifForm.baslangic_tarihi} onChange={e => setTeklifForm({ ...teklifForm, baslangic_tarihi: e.target.value })} /></div>
              <div className="form-group"><label>Gecerlilik Tarihi *</label><input type="date" value={teklifForm.teklif_gecerlilik_tarihi} onChange={e => setTeklifForm({ ...teklifForm, teklif_gecerlilik_tarihi: e.target.value })} /></div>
            </div>
            <div>
              <label style={{ fontSize: '13px', fontWeight: '500', color: 'var(--gri-600)', display: 'block', marginBottom: '6px' }}>Ek Menfaatler</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {MENFAATLER.map(m => (
                  <label key={m.key} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', cursor: 'pointer', background: teklifForm.ek_menfaatler.includes(m.key) ? 'var(--mavi-acik)' : 'var(--beyaz)', color: teklifForm.ek_menfaatler.includes(m.key) ? 'var(--mavi)' : 'var(--yazi)', fontSize: '13px' }}>
                    <input type="checkbox" style={{ display: 'none' }} checked={teklifForm.ek_menfaatler.includes(m.key)} onChange={() => menfaatToggle(m.key)} />
                    {teklifForm.ek_menfaatler.includes(m.key) ? '✓ ' : ''}{m.label}
                  </label>
                ))}
              </div>
            </div>
            <div className="form-group"><label>Notlar</label><textarea value={teklifForm.notlar} onChange={e => setTeklifForm({ ...teklifForm, notlar: e.target.value })} rows={2} /></div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button className="btn btn-secondary" style={{ flex: 1 }} disabled={yukleniyor} onClick={() => islem('/api/adaylar/' + adayId + '/teklif', teklifForm, 'Sozlu teklif kaydedildi.')}>Sozlu Teklif Kaydet</button>
              {teklif?.durum === 'sozlu_yapildi' && (
                <button className="btn btn-primary" style={{ flex: 1 }} disabled={yukleniyor} onClick={() => islem('/api/adaylar/' + adayId + '/teklif/gonder', {}, 'Resmi teklif gonderildi.')}>Resmi Teklif Gonder</button>
              )}
            </div>
            {teklif?.durum === 'resmi_gonderildi' && (
              <div style={{ display: 'flex', gap: '8px' }}>
                <button className="btn btn-primary" style={{ flex: 1 }} disabled={yukleniyor} onClick={() => islem('/api/adaylar/' + adayId + '/teklif/cevap', { cevap: 'kabul' }, 'Kabul kaydedildi.')}>✓ Kabul</button>
                <button className="btn btn-danger" style={{ flex: 1 }} disabled={yukleniyor} onClick={() => islem('/api/adaylar/' + adayId + '/teklif/cevap', { cevap: 'ret' }, 'Red kaydedildi.')}>✗ Red</button>
              </div>
            )}
          </div>
        );

      case 'sozlesme':
        return (
          <div>
            {teklif?.durum === 'kabul_edildi' && <div style={{ background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)', padding: '0.75rem 1rem', fontSize: '14px', color: 'var(--yesil)' }}>Teklif kabul edildi. Sozlesme otomatik olarak adaya gonderildi.</div>}
            {teklif?.durum === 'sozlesme_gonderildi' && <div style={{ fontSize: '14px', color: 'var(--yazi-ikincil)' }}>Sozlesme gonderildi, adayin imzalamasi bekleniyor.</div>}
            {teklif?.durum === 'sozlesme_imzalandi' && <div style={{ background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)', padding: '0.75rem 1rem', fontSize: '14px', color: 'var(--yesil)' }}>✓ Sozlesme imzalandi.</div>}
            {!teklif && <div style={{ fontSize: '14px', color: 'var(--yazi-ikincil)' }}>Teklif asamasi tamamlandiktan sonra sozlesme gonderilecek.</div>}
          </div>
        );

      case 'evraklar':
        return (
          <div>
            {teklif?.durum === 'evraklar_yuklendi'
              ? <div style={{ background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)', padding: '0.75rem 1rem', fontSize: '14px', color: 'var(--yesil)' }}>✓ Tum evraklar teslim edildi.</div>
              : <div style={{ fontSize: '14px', color: 'var(--yazi-ikincil)' }}>Sozlesme imzalandiktan sonra aday evraklarini sisteme yukleyecek.</div>
            }
          </div>
        );
      default: return null;
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '8px' }}>
        <button className="btn btn-secondary btn-sm" onClick={geriDon}>← Listeye Don</button>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button className="btn btn-secondary btn-sm" onClick={() => { setSifrePaneli(!sifrePaneli); setSonuc(null); }}>
            Sifre Sifirla
          </button>
          <button className="btn btn-danger btn-sm" onClick={handleSil}>
            Adayi Sil
          </button>
        </div>
      </div>

      {/* Sifre sifirlama paneli */}
      {sifrePaneli && (
        <div className="card" style={{ marginBottom: '1.5rem', borderLeft: '4px solid var(--mavi)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h3 style={{ fontSize: '15px', fontWeight: '600', margin: 0 }}>Sifre Sifirla</h3>
            <button className="btn btn-secondary btn-sm" onClick={() => { setSifrePaneli(false); setYeniSifre(''); }}>Kapat</button>
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
            <div className="form-group" style={{ flex: 1, margin: 0 }}>
              <label>Yeni Sifre (min 8 karakter)</label>
              <PasswordInput value={yeniSifre} onChange={e => setYeniSifre(e.target.value)} minLength={8} autoComplete="new-password" placeholder="Yeni sifre..." />
            </div>
            <button className="btn btn-primary" disabled={yukleniyor || yeniSifre.length < 8} onClick={handleSifreSifirla}>
              {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
            </button>
          </div>
        </div>
      )}

      {/* Aday bilgileri */}
      <div className="card" style={{ marginBottom: '1.5rem', padding: '1.25rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
          <div className="avatar" style={{ width: '48px', height: '48px', fontSize: '16px', flexShrink: 0 }} data-harf={aday.ad[0] || '?'}>{aday.ad[0]}{aday.soyad[0]}</div>
          <div>
            <h2 style={{ fontSize: '18px', marginBottom: '2px' }}>{aday.ad} {aday.soyad}</h2>
            <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{aday.email}</p>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '0.75rem' }}>
          {[
            { label: 'Telefon', value: aday.telefon },
            { label: 'E-posta', value: aday.email },
            { label: 'Dogum Tarihi', value: aday.dogum_tarihi ? new Date(aday.dogum_tarihi).toLocaleDateString('tr-TR') : '-' },
            { label: 'Emeklilik', value: emeklilikEtiketi[aday.emeklilik_durumu] || '-' },
            { label: 'Sehir / Ilce', value: [aday.sehir, aday.ilce].filter(Boolean).join(' / ') || '-' },
            { label: 'Maas Beklentisi', value: aday.maas_beklentisi ? aday.maas_beklentisi + ' TL' : '-' },
          ].map(item => (
            <div key={item.label} style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '0.6rem 0.75rem' }}>
              <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginBottom: '2px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{item.label}</div>
              <div style={{ fontSize: '13px', fontWeight: '500' }}>{item.value || '-'}</div>
            </div>
          ))}
        </div>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
        <div style={{ flex: 1, height: '1px', background: 'var(--border)' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 16px', background: 'var(--mavi-acik)', borderRadius: '20px' }}>
          <span style={{ fontSize: '13px', fontWeight: '600', color: 'var(--mavi)' }}>Ise Alim Sureci</span>
        </div>
        <div style={{ flex: 1, height: '1px', background: 'var(--border)' }} />
      </div>

      <div className="card" style={{ marginBottom: '1.5rem', padding: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {ADIMLAR.map((adim, index) => {
            const tamamlandi_ = index < aktif;
            const aktif_ = index === aktif;
            const secili = aktifAdim === adim.id;
            return (
              <React.Fragment key={adim.id}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }} onClick={() => setAktifAdim(secili ? null : adim.id)}>
                  <div style={{
                    width: '40px', height: '40px', borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '14px', fontWeight: '600',
                    background: tamamlandi_ ? 'var(--yesil)' : aktif_ || secili ? 'var(--mavi)' : 'var(--gri-200)',
                    color: tamamlandi_ || aktif_ || secili ? 'white' : 'var(--gri-400)',
                    border: secili ? '3px solid var(--mavi-acik)' : aktif_ ? '3px solid #bfdbfe' : 'none',
                    transition: 'all 0.2s',
                    boxShadow: secili ? '0 0 0 3px var(--mavi-acik)' : 'none'
                  }}>
                    {tamamlandi_ ? '✓' : index + 1}
                  </div>
                  <div style={{ marginTop: '8px', textAlign: 'center', maxWidth: '90px' }}>
                    <p style={{ fontSize: '12px', fontWeight: secili || aktif_ ? '600' : '400', color: tamamlandi_ ? 'var(--yesil)' : aktif_ || secili ? 'var(--mavi)' : 'var(--gri-400)', lineHeight: '1.3' }}>
                      {adim.label}
                    </p>
                  </div>
                </div>
                {index < ADIMLAR.length - 1 && (
                  <div style={{ flex: 1, height: '2px', background: index < aktif ? 'var(--yesil)' : 'var(--gri-200)', marginBottom: '28px', minWidth: '20px' }} />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>

      {aktifAdim && (
        <div className="card">
          <div style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
            <h3 style={{ fontSize: '15px', fontWeight: '600' }}>
              {ADIMLAR.find(a => a.id === aktifAdim)?.label}
            </h3>
          </div>
          {adimIcerigi(aktifAdim)}
        </div>
      )}
    </div>
  );
};
export default AdayDetayPage;
